import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { validateEmail } from 'src/lib/utils/helpers'
import { Button } from '@shopflo/ui'

const VerifyEmail = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { email } = router.query

  const [counter, setCounter] = useState<number>(9)

  useEffect(() => {
    if (!Boolean(validateEmail(String(email)))) {
      handleVerifyButtonClick()
    }
  }, [email])

  useEffect(() => {
    const timer: any = counter > 0 ? setInterval(() => setCounter(counter - 1), 1000) : handleVerifyButtonClick()
    return () => clearInterval(timer)
  }, [counter])

  const handleVerifyButtonClick = () => {
    router.replace('/auth/login')
  }

  return (
    <div className='flex flex-col gap-12 min-w-[380px]'>
      <div className='flex flex-col gap-8'>
        <h2 className='text-2xl font-semibold text-zinc-700 items-center text-center'>{t('welcome_to_shopflo')}</h2>
        <p className='text-text-xs-regular text-zinc-500 text-center'>{t('verified_email_text', { email: email })}</p>
      </div>

      <div className='flex flex-col gap-8'>
        <Button onClick={handleVerifyButtonClick} variant='outline' size='lg' className='w-full h-11'>
          {t('verify_email')}
        </Button>

        <p className='text-text-xs-regular text-zinc-500 text-center relative'>
          {t('redirecting_text', { time: counter })}
          <span className='absolute'>{'.'.repeat(3)}</span>
        </p>
      </div>
    </div>
  )
}

export default VerifyEmail
